import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { translate } from '@translations/i18n';
import { formatLocaleDateShort } from '@helpers/dateHelpers';
import { Chip } from '@mui/material';
import { BadgeListCell } from '@components/data-table';
import { mapWeaponGroupsToBadgeItems } from '@helpers/weaponGroups';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { createActionsColumn } from '@helpers/columnsHelper';
import { TableCellAction } from '@components/data-table/actions';
import {
  PortalScoreSubmission,
  SubmissionStatus,
} from '@api/competitionsApi/interfaces';
import { IGetColumns } from './interfaces';

const statusColors: Record<
  SubmissionStatus,
  'success' | 'error' | 'warning'
> = {
  approved: 'success',
  rejected: 'error',
  pending: 'warning',
};

export const getColumns = ({
  onViewScorecard,
}: IGetColumns): GridColDef[] => {
  return [
    {
      field: 'shotOn',
      headerName: translate('competitions:portal.yourScores.columns.shotOn'),
      width: 130,
      renderCell: (params) =>
        formatLocaleDateShort(params.row.shotOn),
    },
    {
      field: 'weaponGroup',
      headerName: translate(
        'competitions:portal.yourScores.columns.weaponGroup'
      ),
      width: 220,
      sortable: false,
      renderCell: (params) => (
        <BadgeListCell
          items={mapWeaponGroupsToBadgeItems(
            params.row.weaponGroup ? [params.row.weaponGroup] : []
          )}
        />
      ),
    },
    {
      field: 'status',
      headerName: translate('competitions:portal.yourScores.columns.status'),
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Chip
          label={translate(
            `competitions:portal.yourScores.status.${params.row.status as SubmissionStatus}`
          )}
          variant="outlined"
          size="small"
          color={statusColors[params.row.status as SubmissionStatus]}
        />
      ),
    },
    {
      field: 'source',
      headerName: translate('competitions:portal.yourScores.columns.source'),
      width: 120,
      renderCell: (params) =>
        translate(
          `competitions:portal.yourScores.source.${params.row.source}`
        ),
    },
    {
      field: 'value',
      headerName: translate('competitions:portal.yourScores.columns.value'),
      width: 90,
      align: 'center',
      headerAlign: 'center',
    },
    createActionsColumn<PortalScoreSubmission>({
      width: 200,
      minWidth: 200,
      renderActions: (score) => (
        <TableCellAction
          aria-label="view-scorecard"
          label={translate('competitions:portal.yourScores.viewScorecard')}
          icon={VisibilityIcon}
          onClick={() => onViewScorecard(score)}
        />
      ),
    }),
  ];
};
